import { StudioState } from '../../types/store';
import { initializePlayground } from '../../actions/studio/playground';

export const handleInitializePlayground = (
  state: StudioState,
  action: ReturnType<typeof initializePlayground>
): StudioState => ({
  ...state,
  playground: {
    subsection: action.payload.subsection,
    isDrawingsTabVisible: false,
  },
});

export const handlePullDrawingsTabStatusSuccess = (state: StudioState, action): StudioState => ({
  ...state,
  playground: {
    ...state.playground,
    isDrawingsTabVisible: action.payload.isDrawingsTabVisible,
  },
});

export const handlePullDrawingsTabStatusFailure = (state: StudioState): StudioState => ({
  ...state,
  playground: {
    ...state.playground,
    isDrawingsTabVisible: false,
  },
});
